export const FilterTypesEnum = {
    free: 1,
    select: 2,
    buttons: 3,
    tags: 4
}